import { angularServicesNames } from "@topline/services/angularServicesNames";

((module) => {
    module.component('cyclesSumChart', {
        template: require('./cyclesSumChartComponent.html'),
        bindings: {
            statisticalForecast: "<",
            pmForecast: "<",
            parameters: "<"
        },
        controller: ['$scope', angularServicesNames.$translate, 'PPGChartAndTableService', 'dtpChartService', 'ChartsConfig', 'calculationPPGService', 'debounce',
            function(
                this: $TSFixMe,
                $scope: $TSFixMe,
                $translate: ng.translate.ITranslateService,
                PPGChartAndTableService: $TSFixMe,
                dtpChartService: $TSFixMe,
                ChartsConfig: $TSFixMe,
                calculationPPGService: $TSFixMe,
                debounce: $TSFixMe
            ) {
                const $ctrl = this;
                
                $scope.$on('LanguageChanged', () => resetChartTranslations());
                resetChartTranslations();
                function resetChartTranslations() {
                    $translate(['CHART_SERIES.FORECAST_BASE', 'CHART_SERIES.FORECAST_AFTER_FACTS'])
                        .then(function (translations: $TSFixMe) {
                            $ctrl.datasetOverride = [
                                {
                                    label: translations["CHART_SERIES.FORECAST_BASE"],
                                    type: 'bar',
                                },
                                {
                                    label: translations["CHART_SERIES.FORECAST_AFTER_FACTS"],
                                    type: 'bar',
                                }];
                        });
                }

                $ctrl.chartOptions = {
                    scales: {
                        yAxes: [{
                            ticks: { suggestedMin: 0 }
                        }]
                    }
                };

                $ctrl.$onInit = () => {
                    $scope.$watch('$ctrl.pmForecast', debounce(function (newVal: $TSFixMe) {
                        if (newVal) {
                            if (!$ctrl.statisticalForecast)
                                $ctrl.statisticalForecast = [];

                            var statisticalForecastCycleSum = calculationPPGService.sumBy($ctrl.statisticalForecast, $ctrl.parameters.forecastStartDate, function (month: $TSFixMe) { return month % 4 == 0; });
                            var pmForecastCycleSum = calculationPPGService.sumBy($ctrl.pmForecast, $ctrl.parameters.forecastStartDate, function (month: $TSFixMe) { return month % 4 == 0; });

                            $ctrl.labels = PPGChartAndTableService.prepareCycleLabelsToChart($ctrl.parameters.forecastStartDate, $ctrl.parameters.forecastEndDate);
                            $ctrl.dataToPPGChart = [
                                statisticalForecastCycleSum,
                                pmForecastCycleSum
                            ];
                        }
                    }), 300);
                };
            }]
    })

})(angular.module("topline.modules"));